export default __webpack_public_path__ + "static/kadet_big-857c3c10adbb806c3aaa230e217c2376.png";